module.exports = __webpack_public_path__ + "static/media/im.775ed2e1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/im.svg
// module id = 2116
// module chunks = 0